function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { InputNumber, Form, Input, Button, notification, Alert, ColorPicker } from "antd";
import Common from "../../includes/Common";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var EditPricePlan = function EditPricePlan(_ref) {
  var plan = _ref.plan,
    handler = _ref.handler;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormLoading = _useState2[0],
    setIsFormLoading = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    errorMessage = _useState4[0],
    setErrorMessage = _useState4[1];
  var _useState5 = useState('#DBB100'),
    _useState6 = _slicedToArray(_useState5, 2),
    color = _useState6[0],
    setColor = _useState6[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var handleColorChange = function handleColorChange(c) {
    setColor(c.toHexString());
  };
  var onFinish = function onFinish(values) {
    setIsFormLoading(true);
    axios.post(Common.baseApiUrl + "editpriceschema", {
      user_id: Common.currentUser.id,
      label: values.label,
      color: color,
      price: values.price,
      available_quantity: values.available_quantity,
      id: plan.id
    }).then(function (response) {
      if (response.data.status == 200) {
        notification.success({
          message: "OK",
          description: "Le pass accès à été modifé !"
        });
        handler();
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setErrorMessage("Une erreur est survenue");
    })["finally"](function () {
      setIsFormLoading(false);
    });
  };
  useEffect(function () {
    form.setFieldsValue({
      label: plan.label,
      price: plan.price,
      available_quantity: plan.available_quantity
    });
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("h6", {
      children: /*#__PURE__*/_jsx("b", {
        children: "MODIFIER LE PASS"
      })
    }), /*#__PURE__*/_jsxs(Form, {
      onFinish: onFinish,
      form: form,
      layout: "vertical",
      children: [errorMessage.length > 0 && /*#__PURE__*/_jsx(Alert, {
        type: "error",
        message: errorMessage
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "label",
        label: "Nom du plan",
        rules: [{
          required: true,
          message: "Veuillez donner un nom au plan"
        }],
        children: /*#__PURE__*/_jsx(Input, {
          showCount: true,
          maxLength: 12,
          placeholder: "Exemple: Ticket VIP"
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(ColorPicker, {
          trigger: "hover",
          onChange: handleColorChange,
          defaultValue: plan.color,
          presets: [{
            label: "Recommandations",
            colors: ['#F5222D', '#FA8C16', '#FADB14', '#8BBB11', '#52C41A', '#13A8A8', '#1677FF', '#2F54EB', '#722ED1', '#EB2F96']
          }]
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "price",
        label: "Prix du ticket",
        rules: [{
          required: true,
          message: "Veuillez donner un prix au plan"
        }],
        children: /*#__PURE__*/_jsx(InputNumber, {
          style: {
            width: "210px"
          }
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "available_quantity",
        label: "Nombre de places maximum",
        children: /*#__PURE__*/_jsx(InputNumber, {
          style: {
            width: "210px"
          }
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          loading: isFormLoading,
          type: "primary",
          htmlType: "submit",
          children: /*#__PURE__*/_jsx("b", {
            children: "MODIFIER"
          })
        })
      })]
    })]
  });
};
export default EditPricePlan;